// extracted by mini-css-extract-plugin
export default {"confirmButton":"axnui-theming-confirm-button__confirm-button__nLWnf"};